import tool from './tool.js';
// 日期-服务
export default {
  /**
   * 获取系统当前时间
   * 
   * @param format 格式
   * @param join 连接符
   */
  systemTime(format = 'second', join = '-') {
    this.convertToString(0, format, join);
  },

  /**
   * 时间戳转字符串
   * 
   * @param timestamp 时间戳
   * @param format 格式
   * @param join 连接符
   */
  convertToString(timestamp, format = 'second', join = '-') {
    const myDate = timestamp == 0 ? new Date() : new Date(timestamp);
    const year = myDate.getFullYear();
    const month = myDate.getMonth() + 1;
    const day = myDate.getDate();
    const hours = tool.formatNumber(myDate.getHours());
    const minutes = tool.formatNumber(myDate.getMinutes());
    const seconds = tool.formatNumber(myDate.getSeconds());
    if (format == 'second' || format == '') {
      return `${year}${join}${month}${join}${day} ${hours}:${minutes}:${seconds}`;
    } else if (format == 'minute') {
      return `${year}${join}${month}${join}${day} ${hours}:${minutes}`;
    } else if (format == 'day') {
      return `${year}${join}${month}${join}${day}`;
    } else if (format == 'date') {
      return `${year}${join}${month}${join}${day}`;
    } else if (format == 'time') {
      return `${hours}:${minutes}:${seconds}`;
    } else {
      return '过滤器格式错误';
    }
  },

  /**
   * 字符串转时间戳
   * 
   * @param string 字符串
   */
  convertToTimestamp(string) {
    string = string.replace(/\-/g, '/');
    return new Date(string).getTime();
  },

  /**
   * 获取某个月有多少天
   * @param year 年
   * @param month 月
   */
  daysCount(year, month) {
    return (new Date(year, month, 0)).getDate();
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/date.js